import Immutable from 'seamless-immutable';
// ---- external imports ----

import * as types from './actionTypes';
// ---- local imports ----

const initialState = Immutable({
	allWarehouses: [],
	leasedWarehouses: [],
	isLoaded: false
});

export default function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.WAREHOUSE_FETCHED_ALL:
		return state.merge({
			allWarehouses: action.allWarehouses,
			isLoaded: true
		});
	case types.WAREHOUSE_FETCHED_LEASED:
		return state.merge({
			leasedWarehouses: action.leasedWarehouses
		});
	default:
		return state;
	}
}
